import React from 'react'
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material'

const notificationOrder = ['invoices', 'orders', 'orders - user specific']

const descriptions = {
  invoices: 'Receive new invoice emails',
  orders: 'Receive order emails when a customer places an order',
  'orders - user specific': 'Receive order emails only when assigned to a customer as the sales person',
}

const NotificationList = ({ value, onChange }) => {
  const toggle = (key) => {
    const checked = !value[key]
    const nextValue = { ...value, [key]: checked }

    if (key === 'orders - user specific' && checked) {
      nextValue.orders = true
    }

    if (key === 'orders' && !checked) {
      nextValue['orders - user specific'] = false
    }

    onChange(nextValue)
  }

  return (
    <FormGroup sx={{ mt: 1 }}>
      {notificationOrder.map((key) => (
        <FormControlLabel
          key={key}
          sx={key === 'orders - user specific' ? { ml: 4 } : undefined}
          control={
            <Checkbox
              checked={Boolean(value[key])}
              onChange={() => toggle(key)}
              name={key}
            />
          }
          label={
            <>
              <strong>{key.toLocaleUpperCase()}</strong>
              {' - '}
              <em>{descriptions[key]}</em>
            </>
          }
        />
      ))}
    </FormGroup>
  )
}

export default NotificationList
